<template>
    <h1 class="text-center p-10">Card Details</h1>
</template>

<script>
export default {
    name: 'CardDetails',
};
</script>
